import { render, staticRenderFns } from "./AddOnsList.vue?vue&type=template&id=5998865d&scoped=true"
import script from "./AddOnsList.vue?vue&type=script&lang=ts"
export * from "./AddOnsList.vue?vue&type=script&lang=ts"
import style0 from "./AddOnsList.vue?vue&type=style&index=0&id=5998865d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5998865d",
  null
  
)

export default component.exports